<template>
  <!-- Dialog Remove Idea -->
  <ib-dialog
    :visible="visible"
    :show-close="false"
    width="400px"
    top="8vh"
    empty-header
    @close="hideDialogRemoveIdea"
  >
    <!-- Dialog Content -->
    <ib-dialog-confirmation-content
      :image="require('@/assets/img/illustrations/delete-note.svg')"
      :title="$t('dialogs.removeIdea.title')"
      :subtitle="$t('areYouSureYouWantToDeleteThisIdea')"
    />
    <!-- /Dialog Content -->

    <!-- Dialog Footer -->
    <template #footer>
      <ib-divider block class="mb-4" />
      <ib-dialog-footer
        button-size="md"
        :loading="loading"
        :submit-btn-text="$t('delete')"
        :cancel-btn-text="$t('cancel')"
        variant-button="red"
        @cancel="hideDialogRemoveIdea"
        @submit="removeIdea"
      />
    </template>
    <!-- /Dialog Footer -->
  </ib-dialog>
  <!-- /Dialog Remove Idea -->
</template>

<script>
export default {
  name: 'DialogRemoveIdea',

  props: {
    visible: {
      default: false,
      type: Boolean
    },

    hideDialogRemoveIdea: {
      type: Function,
      default: function () {}
    },

    removeIdea: {
      type: Function,
      default: function () {}
    }
  },

  data () {
    return {
      loading: false
    }
  }
}
</script>
